export default {"src":"/_next/static/media/platinum.93b6db43.svg","height":103,"width":356,"blurWidth":0,"blurHeight":0};